import { useState } from 'react';
import { usePersons } from '../api/queries/persons';

// Searchable person typeahead over GET /api/persons?q=. Calls onSelect with the
// chosen person's id + display name. Reusable wherever a record needs to be
// linked to a person in the registry (currently the admin user detail page).
export function PersonPicker({
  onSelect,
}: {
  onSelect: (person: { id: number; full_name: string }) => void;
}): JSX.Element {
  const [q, setQ] = useState('');
  const { data, isFetching } = usePersons(q.trim() ? { q: q.trim() } : {});
  const persons = data?.persons ?? [];

  return (
    <div className="person-picker">
      <input
        className="form-input"
        type="search"
        placeholder="Search people…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        autoFocus
      />
      {isFetching && <p className="muted small">Searching…</p>}
      <ul className="person-picker-results">
        {!isFetching && persons.length === 0 && (
          <li className="muted small">No matches.</li>
        )}
        {persons.slice(0, 20).map((p) => (
          <li key={p.id}>
            <button
              type="button"
              className="btn btn-ghost btn-sm"
              onClick={() => onSelect({ id: p.id, full_name: p.full_name })}
            >
              {p.full_name}
              {p.preferred_name ? ` (${p.preferred_name})` : ''}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
